// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8c8f18b1","38":"afafa8f0","217":"355bfdb0","247":"dc54cabd","312":"663ca761","396":"465e24ef","453":"f930f509","459":"41d0163f","545":"82734b4c","553":"78f66b40","627":"c4891fa5","701":"7a050ccc","808":"e1bc045d","857":"20142921"}[chunkId] + ".chunk.js";
};